import React from "react";
import { Typography, Link } from "@mui/material";
import PageShell from "../components/PageShell";
import PageTitle from "../components/PageTitle";

export default function Privacy() {
  return (
    <PageShell>
      <PageTitle>Privacy Policy</PageTitle>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We respect your privacy. This service stores the minimum data required to
        operate your account, billing, and feature usage (e.g., credits).
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
        {`• Authentication is handled by Supabase.\n• Payments are processed by Stripe.\n• We don’t sell your data.\n• You can request data export/deletion at any time.`}
      </Typography>
      <Typography variant="body2" sx={{ mt: 3 }}>
        Questions? <Link href="mailto:info@mtinnotech.org">info@mtinnotech.org</Link>
      </Typography>
    </PageShell>
  );
}
